import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "cancellationsToggle",
    "pauseToggle",
    "transfersToggle",
    "radioSection",
    "radio",
  ];

  connect() {
    this.updateAllRadioStates();
  }

  toggleCancellationsEnabled() {
    setTimeout(() => {
      this.updateAllRadioStates();
    }, 10);
  }

  togglePause() {
    setTimeout(() => {
      this.#updateFlowOptionState("pause");
    }, 10);
  }

  handleTransferChange() {
    setTimeout(() => {
      this.#updateFlowOptionState("transfer");
    }, 10);
  }

  updateAllRadioStates() {
    const cancellationsEnabled = this.#getCancellationsEnabled();

    this.#updateRadioSection(cancellationsEnabled);
    this.#updateFlowOptionState("pause");
    this.#updateFlowOptionState("transfer");
  }

  #updateRadioSection(cancellationsEnabled) {
    this.radioTargets.forEach((input) => {
      const flowValue = input.value;

      // Only set state for non-pause/transfer options (those are handled by updateFlowOptionState)
      if (flowValue !== "pause" && flowValue !== "transfer") {
        this.#setRadioState(input, !cancellationsEnabled);
      }

      // Show cancellations error for selected option when cancellations disabled
      const cancellationsError = this.#getErrorTarget(flowValue, "Cancellations");
      const showError = input.checked && !cancellationsEnabled;
      cancellationsError?.classList.toggle("hidden", !showError);
    });

    // Toggle opacity on the entire radio section
    if (this.hasRadioSectionTarget) {
      this.radioSectionTarget.classList.toggle("opacity-50", !cancellationsEnabled);
    }
  }

  #updateFlowOptionState(flowValue) {
    const cancellationsEnabled = this.#getCancellationsEnabled();
    const dependentEnabled = this.#getDependentToggleEnabled(flowValue);
    const radio = this.#getRadioByValue(flowValue);

    if (!radio) return;

    const disabled = !cancellationsEnabled || !dependentEnabled;
    this.#setRadioState(radio, disabled);

    // Show error when the dependency is disabled
    const errorContainer = this.#getErrorTarget(flowValue, "");
    const showError = !dependentEnabled && cancellationsEnabled;
    errorContainer?.classList.toggle("hidden", !showError);
  }

  #getRadioByValue(flowValue) {
    return this.radioTargets.find((radio) => radio.value === flowValue);
  }

  #getErrorTarget(flowValue, errorType) {
    const targetName = `${flowValue}${errorType}Error`;
    return this.element.querySelector(
      `[data-support-agent--cancellation-flow-validation-target="${targetName}"]`
    );
  }

  #setRadioState(radio, disabled) {
    const label = radio.closest("label");
    const wrapper = label?.parentElement;

    if (disabled) {
      radio.setAttribute("aria-disabled", "true");
      if (label) {
        label.classList.add("opacity-50");
        label.style.pointerEvents = "none";
      }
      if (wrapper) {
        wrapper.style.cursor = "not-allowed";
      }
    } else {
      radio.removeAttribute("aria-disabled");
      if (label) {
        label.classList.remove("opacity-50");
        label.style.pointerEvents = "";
      }
      if (wrapper) {
        wrapper.style.cursor = "";
      }
    }
  }

  #getCancellationsEnabled() {
    return this.cancellationsToggleTarget?.value === "true";
  }

  #getDependentToggleEnabled(flowValue) {
    if (flowValue === "pause") {
      return this.hasPauseToggleTarget && this.pauseToggleTarget.value === "true";
    } else if (flowValue === "transfer") {
      return this.hasTransfersToggleTarget && this.transfersToggleTarget.value === "true";
    }
    return true;
  }
}
